import { ReactNode } from 'react';
import { CSS } from '@stitches/react';

import { DropdownItem } from '@base-app';

export enum Direction {
  ROW = 'row',
  COLUMN = 'column',
}

export interface CardGridProps {
  children: ReactNode;
  css?: CSS;
  direction?: Direction;
  infoPanel?: ReactNode;
  isReverse?: boolean;
  handleClick?: (item: DropdownItem) => void;
  headerOptions?: DropdownItem[];
  title?: ReactNode | string;
}
